import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ptg-municipality-group-aggregation',
  templateUrl: './municipality-group-aggregation.component.html',
  styleUrls: ['./municipality-group-aggregation.component.scss']
})
export class MunicipalityGroupAggregationComponent implements OnInit {
  @Input() aggregationDetails: any = [];
  constructor() { }

  ngOnInit(): void {
  }

}
